import { apiRequest } from '@common/api/utils';

function applicationInfo(params = {}) {
  return apiRequest('GET', '/api/v3/referrals/coupon-application-info', params);
}

export default {
  applicationInfo,
};
